<app-inventory-campaign-details-form> </app-inventory-campaign-details-form>
<br />
<app-inventory-campaign-details-table></app-inventory-campaign-details-table>
